import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import Spinner from 'react-spinkit';
import { loadBrandIndex } from './actions';
import { brandUrl } from 'shared/models/product';

let Brands = class Brands extends React.Component {
  componentDidMount() {
    if (!this.props.brandIndex || this.props.brandIndex.length === 0) {
      this.props.loadBrandIndex();
    }
  }

  render() {
    return (
      <div className="banner-padding">
        <div className="brand-page__header">
          <div className="brand-page__heading-label">Shop</div>
          <h1 className="brand-page__heading">Brands We Love</h1>
          <hr className="light" />
        </div>
        <div className="brand-page__container">
          {this.props.brandIndexLoading ? (
            <Spinner spinnerName="three-bounce" />
          ) : (
            <dl className="brand-index">
              {this.props.brandIndex.map(brandGroup => (
                <div
                  key={brandGroup.key}
                  className="brand-index__group-container"
                >
                  <dt className="brand-index__group-key">{brandGroup.key}</dt>
                  <hr className="light brand-index__group-divider" />
                  <dd className="brand-index__group-contents">
                    <ol className="brand-index__list">
                      {_.uniq(brandGroup.brands).map(brand => (
                        <li key={brand} className="brand-index__list-item">
                          <Link to={brandUrl(brand)}>{brand}</Link>
                        </li>
                      ))}
                    </ol>
                  </dd>
                </div>
              ))}
            </dl>
          )}
        </div>
      </div>
    );
  }
};

Brands = connect(
  state => ({
    brandIndex: state.brands.index,
    brandIndexLoading: state.brands.indexLoading
  }),
  {
    loadBrandIndex
  }
)(Brands);

export default Brands;



// WEBPACK FOOTER //
// ./shared/components/brands/index.js